import { render, staticRenderFns } from "./ImageMappingConfig.vue?vue&type=template&id=568979a4&scoped=true"
import script from "./ImageMappingConfig.vue?vue&type=script&lang=js"
export * from "./ImageMappingConfig.vue?vue&type=script&lang=js"
import style0 from "./ImageMappingConfig.vue?vue&type=style&index=0&id=568979a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568979a4",
  null
  
)

export default component.exports